// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__1X-du","title":"Images90_title__2I4Vs","images":"Images90_images__20lHf"};